import React , {useEffect, useRef, useState}from 'react'
import Slider from 'react-slick'
import Navbar from '../../Components/Navbar/Navbar'
import PendingAdItem from '../../Components/PendingAdItem/PendingAdItem'
import { setting } from '../../Common/setting'

import './ViewAd.css'
import '../../Components/ProfileCard/ProfileCard.css'
import { useNavigate, useParams } from 'react-router-dom'
import UserApi from '../../Common/Api/UserApi'
import { useSelector } from 'react-redux'
import Cookies from "js-cookie";

const ViewAd = (props) => {
    // const [book,setBook] = useState({title:"",images:[],price:"",edition:"",damage:"",totalPages:"",pagesMarked:"",authors:""});
    setting.dots = false;

    const [quotePrice,setQuotePrice] = useState(false)
    
    const [deleteAd,setDeleteAd] = useState(false)
    const [message,setMessage] = useState(false)

    // Getting ads array
    const {BookWormAdmin,Books} = useSelector((state)=>{
        return (state);
      })
    
    const {categories} = Books;
      
    const {pendingAds , notifications } = BookWormAdmin;

    const {id} = useParams();
    const adId = id.substring(1);

    const [ad,setAd] = useState({images:[],authors:[]});
    const [selectedCategories,setSelectedCategories] = useState([]);

    const fetchAdDetails = async()=>{
        // const {data} = await UserApi.get(`/ads/${adId}`);
        console.log(pendingAds)
        let found = pendingAds.find(x => x._id === adId)
        
        if(!found)
        {
            found = notifications.find(x=>x._id===adId)
            console.log(notifications)
        }

        console.log("view ad : ",found)
        setAd(found);
    }

    useEffect(() => {
        
        fetchAdDetails();
        
    }, [])
    
    const [adminMessage,setAdminMessage] = useState({message:"Please Take Good and Clear Photos of book and Post an AD again. Ads with good Photos have higher chances of getting Sold !",quotedPrice:''});
    
    const changeAdminMessage = (e)=>{
        e.preventDefault();
        setAdminMessage({...adminMessage, [e.target.name] : e.target.value});
    }
    
    const handleSendMessage =async ()=>{
        
        if(!adminMessage.quotedPrice)
        {
            alert('Please Quote a price to User');
            return;
        }
        const data = await UserApi.post(`admin/ads/${adId}/quote-price`,{
            price:adminMessage.quotedPrice,
            message:adminMessage.message
        })
        
        console.log(data);
        navigate(-1)
    }
    
    const navigate = useNavigate();
    
    const handlePostAd = async ()=>{
        
        const data = await UserApi.post(`admin/ads/${adId}/approve`,{
            categories:selectedCategories
        },{
            headers: {
                'Authorization': `Bearer ${Cookies.get('token')}`
            }
        })
        console.log("data recived from approve route : ",data);
        navigate('/dashboard');
        
    }
    const checkboxRef = useRef();
    
    const selectCategory = (element)=>{
        
        console.log("selected categories : ",selectedCategories);
      
        const categoryobj = {
            name : element.name.toLowerCase(),
            _id:element._id
        }

        let flag=false;
        selectedCategories.map((ele)=>{
            if(ele._id==categoryobj._id)
            {
                flag=true;
                return;
            }
        })
        

        if(flag)
        {
            setSelectedCategories(selectedCategories.filter((ele)=>ele._id!=element._id));
        }
        else{
            setSelectedCategories([...selectedCategories,categoryobj])
        }
        
    }

    const handleDeleteAd = async()=>{
        const res = await UserApi.delete(`admin/ads/${adId}/delete`);
        console.log(res);
        navigate(-1);
    }

    console.log(ad);
    // console.log(selectedCategories)
  return (
    <>
    <Navbar colorRight="#5f2c3e" colorLeft="#5f2c3e"  />
    <div className='viewAd-container'>
        
        
        <div className='req-container'>
            
            <h2 style={{color:"rgb(57, 57, 57)"}} >Ttile - {ad.title}</h2>
            {(ad.images.length <=3)? 
                <div className='row' >
                    {
                     ad.images.map((element) => {
                       
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                            <PendingAdItem displayInfo = "false" img={element} />
                        </div>
                         
                        )})
                    }
                </div>:
                <div className='carrousel-cont'>
                <Slider {...setting}>
                {
                   ad.images.map((element) => {
                     
                    return (
                        <PendingAdItem displayInfo = "false" img={element} />
                    )})
                }
                </Slider>
                </div>
            }
            
            <div className='viewAd-main'>
                <div className='view-ad-details'>

                    <div className='ad-details-row'>
                        <div className='ad-detail'> <b>Authors - </b> { ad.authors.map((element)=>{
                            return (
                                <span>{element}</span>
                            );
                        }) }
                        </div>
                        <div className='ad-detail'> <b>Price - </b> {ad.price}</div>
                        <div className='ad-detail'> <b>Book Edition -</b>  {ad.edition}</div>
                    </div>
                    <div className='ad-details-row'>
                        <div className='ad-detail'> <b>Damage on Book -</b>  {ad.damage}</div>
                        <div className='ad-detail'> <b> Total Pages -</b> {ad.totalPages}</div>
                        <div className='ad-detail'> <b>Number of Marked Pages -</b>  {ad.markedPages}</div>
                    </div>

                </div>
                <div className='view-ad-details'>
                    <div className='ad-details-row'>
                        <div className='ad-detail'><b>User Status :</b> {ad.accepted?'Accepted by User' :'Rejected by User'}</div>
                        <div className='ad-detail'> <b>Price Quoted by You :</b>{ad.quotedPrice}</div>
                    </div>    
                    <div className='ad-details-row'>

                        <div className='ad-detail'> <b>Last Message by You :</b>{ad.message}</div>
                    </div>    
                </div>
            </div>

            <div className='view-ad-buttons-container'>
                {/* if accepted by user -> shouldnt be quoted */}
                {(ad.accepted)?'':<button className='view-ad-btn' onClick={()=>setQuotePrice(true)}>Quote Price</button>}
                {(ad.accepted)?'':<button disabled={(ad.accepted)} className='view-ad-btn' onClick={()=>setMessage(true)}>Add additional Message</button>}
                <button className='view-ad-btn' onClick={()=>setDeleteAd(true)}>Delete Ad</button>
                { (ad.accepted)? <button className='view-ad-btn ' data-bs-toggle="modal" data-bs-target="#exampleModal">Add Categories</button>:''}

                
            </div>
            
            {/* if this component is opened through notifi of accepted ads*/}
            {ad.accepted?'': <div className='message-container'>
                <h3>Message to User : </h3>
                <div className='message'>
                    <div className='ad-detail'><b>Quoted Price -</b> {adminMessage.quotedPrice}</div>
                    <div className='ad-detail'><b>Additional Message -</b> {adminMessage.message}</div>
                </div>
            </div>}

            {/* Modals */}
            {message && <div className='Modal'>
                <div className='modal-container' >
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setMessage(false)}></i>
                    <h4>Add your Message Here : </h4>
                    <input type="text" name='message' value={adminMessage.message} onChange={changeAdminMessage}/>
                    <button onClick={()=>setMessage(false)} style={{marginRight:'2%'}}>Confirm</button>
                    <button onClick={()=>setAdminMessage({...adminMessage,message:''})}>Clear Message</button>
                </div>
            </div>}

            {quotePrice && <div className='Modal'>
                <div className='modal-container'>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setQuotePrice(false)}></i>
                    <h4>Enter the Price to Quote to User</h4>
                    <input type="number" name='quotedPrice' value={adminMessage.quotedPrice} onChange={changeAdminMessage}/>
                    <button onClick={()=>setQuotePrice(false)}>Set Price</button>
                </div>
            </div>}

            {deleteAd && <div className='Modal'>
                <div className='modal-container'>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setDeleteAd(false)}></i>
                    <h4>Are you sure you want to Delete this AD?</h4>
                    
                    <button onClick={handleDeleteAd}>Confirm</button>
                </div>
            </div>}

            {/* <!-- Modal --> */}
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Add Categories to Book</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div className='modal-container' style={{padding:'0'}}>
                        
                        <h4 >Select from these Categories :</h4>
                        <div className='category-display'>
                        {
                            categories.map((element)=>{
                                return (
                                <div className='select-categories-container' >
                                    
                                    <label>{element.name}</label>
                                    <input type='checkbox' ref={checkboxRef} onClick={()=>selectCategory(element)}></input>  
                                </div>
                                )
                                
                            })

                            
                        }
                        </div>
            
                        <h4>Selected Categories : </h4>
                        <div className='category-display'  style={{paddingLeft:"0",paddingBottom:"1%"}}>
                        {
                            selectedCategories.map((element)=>{
                                return (
                                <label className='category-display-btn' style={{backgroundColor:"#5f2c3e",color:"white",border: "1px solid #5f2c3e"}}>
                                    {element.name}
                                </label>
                                
                                )
                            })
                        }
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary form-btn" data-bs-dismiss="modal">Save changes</button>
                </div>
                </div>
            </div>
            </div>

            {ad.accepted? <button className='send-final-btn' onClick={handlePostAd}>Post Ad to Website</button>:<button className='send-final-btn' onClick={handleSendMessage}>Send Message to User</button>}

        </div>
        
    </div>
    </>
  )
}

export default ViewAd